import React from "react";
import { Box } from "@mui/material";

import { ReactComponent as PagerdutyIcon } from "../../../../assets/integrations/brands/pagerduty.svg";
import { ReactComponent as OpsgenieIcon } from "../../../../assets/integrations/brands/opsgenie.svg";
import { ReactComponent as SplunkIcon } from "../../../../assets/integrations/brands/splunk.svg";
import { ReactComponent as ServicenowIcon } from "../../../../assets/integrations/brands/servicenow.svg";
import { ReactComponent as LinearIcon } from "../../../../assets/integrations/brands/linear.svg";
import { ReactComponent as ZendeskIcon } from "../../../../assets/integrations/brands/zendesk.svg";
import { ReactComponent as FreshdeskIcon } from "../../../../assets/integrations/brands/freshdesk.svg";
import { ReactComponent as SlackIcon } from "../../../../assets/integrations/brands/slack.svg";
import { ReactComponent as MicrosoftteamsIcon } from "../../../../assets/integrations/brands/microsoft-teams.svg";
import { ReactComponent as MattermostIcon } from "../../../../assets/integrations/brands/mattermost.svg";
import { ReactComponent as WebexIcon } from "../../../../assets/integrations/brands/webex.svg";
import { ReactComponent as DatadogIcon } from "../../../../assets/integrations/brands/datadog.svg";
import { ReactComponent as SumologicIcon } from "../../../../assets/integrations/brands/sumo-logic.svg";
import { ReactComponent as AmazonawsIcon } from "../../../../assets/integrations/brands/aws-amazon-cloudwatch.svg";
import { ReactComponent as ElasticsearchIcon } from "../../../../assets/integrations/brands/elasticsearch.svg";
import { ReactComponent as GooglecloudIcon } from "../../../../assets/integrations/brands/gcp-stackdriver.svg";
import { ReactComponent as FirehydrantIcon } from "../../../../assets/integrations/brands/firehydrant.svg";
import { ReactComponent as JiraIcon } from "../../../../assets/integrations/brands/jira.svg";
import { ReactComponent as DiscordIcon } from "../../../../assets/integrations/brands/discord.svg";
import { ReactComponent as IbmIcon } from "../../../../assets/integrations/brands/ibm.svg";
import { ReactComponent as GeneralIcon } from "../../../../assets/integrations/brands/general.svg";
import { ReactComponent as SyslogIcon } from "../../../../assets/integrations/brands/syslog.svg";

const BRAND_ICONS = {
  pagerduty: { Icon: PagerdutyIcon, multicolor: true },
  opsgenie: { Icon: OpsgenieIcon, multicolor: true },
  victorops: { Icon: SplunkIcon, multicolor: true, scale: 2.08 },
  firehydrant: { Icon: FirehydrantIcon, color: "#E85D2D" },
  jira: { Icon: JiraIcon, multicolor: true },
  servicenow: { Icon: ServicenowIcon, multicolor: true },
  linear: { Icon: LinearIcon, multicolor: true },
  zendesk: { Icon: ZendeskIcon, multicolor: true },
  freshdesk: { Icon: FreshdeskIcon, multicolor: true },
  slack_app: { Icon: SlackIcon, multicolor: true },
  slack_webhook: { Icon: SlackIcon, multicolor: true },
  teams: { Icon: MicrosoftteamsIcon, multicolor: true },
  discord: { Icon: DiscordIcon, multicolor: true },
  mattermost: { Icon: MattermostIcon, color: "#0058CC" },
  webex: { Icon: WebexIcon, multicolor: true },
  datadog: { Icon: DatadogIcon, multicolor: true },
  splunk: { Icon: SplunkIcon, multicolor: true, scale: 2.08 },
  sumo: { Icon: SumologicIcon, multicolor: true, scale: 2.496 },
  sumologic: { Icon: SumologicIcon, multicolor: true, scale: 2.496 },
  general: { Icon: GeneralIcon, color: "#6371F7" },
  aws: { Icon: AmazonawsIcon, multicolor: true },
  elastic: { Icon: ElasticsearchIcon, multicolor: true },
  elasticsearch: { Icon: ElasticsearchIcon, multicolor: true },
  google: { Icon: GooglecloudIcon, multicolor: true },
  googlecloud: { Icon: GooglecloudIcon, multicolor: true },
  ibm: { Icon: IbmIcon, multicolor: true },
  syslog: { Icon: SyslogIcon, color: "#6B7280" },
};

export function IntegrationBrandIcon({ id, size = 48 }) {
  const brand = BRAND_ICONS[id] || BRAND_ICONS.general;
  const { Icon, color, multicolor, scale = 1 } = brand;
  const layoutWidth = scale > 1 ? Math.round(size * scale) : size;

  return (
    <Box
      sx={{
        width: layoutWidth,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 0,
        overflow: "visible",
      }}
    >
      <Box
        sx={{
          width: size,
          height: size,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transform: scale !== 1 ? `scale(${scale})` : undefined,
          "& svg": {
            width: "100%",
            height: "100%",
            display: "block",
          },
          ...(!multicolor && color
            ? {
              color,
              "& path": { fill: "currentColor" },
            }
            : {}),
        }}
      >
        <Icon aria-hidden />
      </Box>
    </Box>
  );
}
